import React,{ useEffect, useState } from 'react';
import { Layout, Space, Grid, Button, Tooltip, Input, Card } from 'antd';
import { useMsal } from '@azure/msal-react';
import { UserProfileIcon } from '../Atoms/UserProfileIcon';
import { NotificationIcon } from '../Atoms/NotificationIcon';
import { CountryFlagDropdown } from './CountryFlagDropdown';
import updatedLogo from "../../assets/images/New_ApteanThanks_Logo.png";
import { LogoutOutlined, QuestionCircleOutlined, HeartOutlined, CloseOutlined, SendOutlined, SmileOutlined } from '@ant-design/icons'; // Import the sign-out and question icons
import PendingReviewsBadge from '../Atoms/PendingReviewsBadge';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
const { useBreakpoint } = Grid;

interface AppHeaderProps {
  logo?: string;
}

const AppHeaderHomePageTemplate: React.FC<AppHeaderProps> = ({
  logo = updatedLogo,
}) => {
  const screens = useBreakpoint();
  const { instance } = useMsal();
  const navigate = useNavigate(); // Add this line
  const [showWomenDayForm, setShowWomenDayForm] = useState(false);
  const [message, setMessage] = useState('');
  const [selectedEmoji, setSelectedEmoji] = useState('');

  const emojiCategories = {
    'Hearts & Love': ['❤️', '💝', '💖', '💗', '💕', '😍', '😘', '🥰'],
    'Flowers': ['💐', '🌸', '🌹', '🌺', '🌷', '🏵️', '🌻'],
    'Smileys': ['😊', '🤗', '🥳', '😄', '😁', '🙏', '👏'],
    'Women': ['👩', '👩‍💼', '👩‍🎓', '👩‍⚕️', '👩‍🔬', '👩‍💻', '👩‍🏫', '👩‍🎨', '💃', '🙋‍♀️', '🙆‍♀️', '💁‍♀️'],
    'Celebration': ['✨', '🎉', '👑', '💪', '🌟', '🦋', '🎀', '🎊']
  };

  // Add animation styles
  const pulseAnimation = `
    @keyframes pulse-glow {
      0%, 100% {
        box-shadow: 0 0 10px rgba(255, 20, 147, 0.6), 0 0 20px rgba(255, 105, 180, 0.4);
        transform: scale(1);
      }
      50% {
        box-shadow: 0 0 20px rgba(255, 20, 147, 0.8), 0 0 30px rgba(255, 105, 180, 0.6);
        transform: scale(1.05);
      }
    }
    @keyframes theaterScreenDrop {
      0% {
        transform: translateY(-100%);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes floatingHearts {
      0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0.6;
      }
      50% {
        opacity: 0.8;
      }
      100% {
        transform: translateY(-100vh) rotate(360deg);
        opacity: 0;
      }
    }
    @keyframes gradientBorder {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
    @keyframes confetti {
      0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
      }
      100% {
        transform: translateY(100vh) rotate(720deg);
        opacity: 0;
      }
    }
    @keyframes emojiGlow {
      0%, 100% {
        box-shadow: 0 0 15px rgba(255, 20, 147, 0.6);
      }
      50% {
        box-shadow: 0 0 25px rgba(255, 20, 147, 0.9);
      }
    }
  `;

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.innerText = pulseAnimation;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

    const handleSignOut = () => {
      localStorage.clear();
      instance.logoutRedirect({
      postLogoutRedirectUri: "/awards",
    });
  };

  const handleLogoClick = () => {
    window.location.href = "/awards/home"; // Redirect to the homepage
  };

  const handlehelp = () => {
    navigate('/helpdata'); // Redirect to the help section
  };

  const handleWomenDaySpecial = () => {
    setShowWomenDayForm(!showWomenDayForm);
  };

  const handleSubmitMessage = () => {
    if (message.trim() && message.trim().length >= 10) {
      // Show confetti animation
      const confettiColors = ['#FF1493', '#FF69B4', '#FFB6C1', '#FFC0CB'];
      for (let i = 0; i < 30; i++) {
        const confetti = document.createElement('div');
        confetti.style.position = 'fixed';
        confetti.style.width = '10px';
        confetti.style.height = '10px';
        confetti.style.backgroundColor = confettiColors[Math.floor(Math.random() * confettiColors.length)];
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.top = '0';
        confetti.style.borderRadius = '50%';
        confetti.style.zIndex = '10001';
        confetti.style.animation = `confetti ${2 + Math.random() * 2}s linear forwards`;
        confetti.style.animationDelay = Math.random() * 0.5 + 's';
        document.body.appendChild(confetti);
        setTimeout(() => confetti.remove(), 4000);
      }
      
      console.log('Message submitted:', message, 'Emoji:', selectedEmoji);
      // Add your API call here to submit the message
      setTimeout(() => {
        alert(`Message sent: ${message} ${selectedEmoji}`);
        setMessage('');
        setSelectedEmoji('');
        setShowWomenDayForm(false);
      }, 500);
    } else if (message.trim() && message.trim().length < 10) {
      alert('Message must be at least 10 characters long');
    }
  };

  const handleEmojiSelect = (emoji: string) => {
    setSelectedEmoji(emoji);
  };


  return (
    <>
      {/* Women Day Special Dropdown Form */}
      {showWomenDayForm && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setShowWomenDayForm(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.7)',
              zIndex: 9998,
            }}
          />
          {/* Full Screen Layer */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              animation: 'theaterScreenDrop 0.4s ease-out',
              display: 'flex',
              flexDirection: 'column',
              background: 'linear-gradient(180deg, #FF1493 0%, #FF69B4 50%, #FFB6C1 100%)',
              overflow: 'hidden',
              willChange: 'transform, opacity',
            }}
          >
            {/* Theater Screen Roller/Rod at top */}
            <div style={{
              position: 'absolute',
              top: '0',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '12px',
              background: 'linear-gradient(90deg, #333 0%, #666 50%, #333 100%)',
              boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
              zIndex: 10000,
            }}>
              {/* Roller end caps */}
              <div style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '16px',
                height: '16px',
                background: '#222',
                borderRadius: '50%',
                boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.2)',
              }}/>
              <div style={{
                position: 'absolute',
                right: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '16px',
                height: '16px',
                background: '#222',
                borderRadius: '50%',
                boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.2)',
              }}/>
            </div>

            {/* Content Container */}
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '30px 20px 20px',
            }}>
              {/* Close Button */}
              <Button
                type="text"
                icon={<CloseOutlined style={{ fontSize: '20px' }} />}
                onClick={() => setShowWomenDayForm(false)}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  color: '#FFFFFF',
                  width: '45px',
                  height: '45px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '50%',
                }}
              />

              {/* Floating Background Hearts */}
              <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
                {[...Array(6)].map((_, i) => (
                  <div key={i} style={{
                    position: 'absolute',
                    fontSize: '25px',
                    opacity: 0.15,
                    left: `${15 + i * 15}%`,
                    animation: `floatingHearts ${3 + i * 0.5}s ease-in-out infinite`,
                    animationDelay: `${i * 0.3}s`,
                  }}>
                    {i % 3 === 0 ? '💖' : i % 3 === 1 ? '🌸' : '✨'}
                  </div>
                ))}
              </div>

              {/* Main Content Card */}
              <div style={{
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '20px',
                padding: '25px 30px',
                maxWidth: '1050px',
                width: '100%',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                transform: 'translateZ(0)',
                position: 'relative',
                zIndex: 1,
                animation: 'gradientBorder 3s ease-in-out infinite',
                border: '3px solid transparent',
                backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), linear-gradient(45deg, #FF1493, #FF69B4, #FFB6C1, #FF1493)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
              }}>
                {/* Decorative Corner Elements */}
                <div style={{ position: 'absolute', top: '10px', left: '10px', fontSize: '28px', opacity: 0.7 }}>🌺</div>
                <div style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '28px', opacity: 0.7 }}>🌸</div>
                <div style={{ position: 'absolute', bottom: '10px', left: '10px', fontSize: '28px', opacity: 0.7 }}>🌷</div>
                <div style={{ position: 'absolute', bottom: '10px', right: '10px', fontSize: '28px', opacity: 0.7 }}>🌹</div>
                {/* Header */}
                <div style={{
                  textAlign: 'center',
                  marginBottom: '18px',
                }}>
                  <div style={{ fontSize: '38px', marginBottom: '5px' }}>💐</div>
                  <h2 style={{
                    color: '#FF1493',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    margin: 0,
                    marginBottom: '4px',
                  }}>
                    Women's Day Special
                  </h2>
                  <p style={{
                    color: '#8629A4',
                    fontSize: '13px',
                    margin: 0,
                  }}>
                    Share your inspiring message and celebrate women
                  </p>
                </div>

                {/* Two Column Layout */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1.5fr 1fr',
                  gap: '20px',
                  marginBottom: '18px',
                }}>
                  {/* Left Column - Message Input */}
                  <div>
                    <label style={{
                      color: '#8629A4',
                      fontWeight: '600',
                      marginBottom: '6px',
                      display: 'block',
                      fontSize: '14px',
                    }}>
                      Your Message:
                    </label>
                    <Input.TextArea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Share your Women's Day message here..."
                      maxLength={500}
                      showCount
                      style={{
                        borderColor: '#FF69B4',
                        borderRadius: '12px',
                        fontSize: '14px',
                        padding: '10px',
                        resize: 'none',
                        height: '210px',
                      }}
                    />
                    {/* Character Counter Progress */}
                    <div style={{
                      marginTop: '6px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      fontSize: '12px',
                    }}>
                      <span style={{
                        color: message.length >= 10 ? '#52c41a' : '#ff4d4f',
                        fontWeight: '500',
                      }}>
                        {message.length >= 10 ? '✓ Ready to send!' : `⚠ ${10 - message.length} more characters needed`}
                      </span>
                      <div style={{
                        width: '120px',
                        height: '4px',
                        background: '#f0f0f0',
                        borderRadius: '2px',
                        overflow: 'hidden',
                      }}>
                        <div style={{
                          height: '100%',
                          width: `${Math.min((message.length / 10) * 100, 100)}%`,
                          background: message.length >= 10 
                            ? 'linear-gradient(90deg, #52c41a, #73d13d)' 
                            : 'linear-gradient(90deg, #ff4d4f, #ff7875)',
                          transition: 'width 0.3s ease',
                        }} />
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Emoji Picker */}
                  <div>
                    <label style={{
                      color: '#8629A4',
                      fontWeight: '600',
                      marginBottom: '6px',
                      display: 'block',
                      fontSize: '14px',
                    }}>
                      <SmileOutlined /> Pick Emoji:
                    </label>
                    <div style={{
                      background: 'linear-gradient(135deg, #FFF5F7 0%, #FFE4E9 100%)',
                      borderRadius: '12px',
                      border: '2px solid #FFB6C1',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      padding: '8px',
                    }}>
                      {Object.entries(emojiCategories).map(([category, emojis]) => (
                        <div key={category} style={{ marginBottom: '8px' }}>
                          <div style={{
                            fontSize: '11px',
                            fontWeight: '600',
                            color: '#8629A4',
                            marginBottom: '4px',
                            paddingLeft: '4px',
                          }}>
                            {category}
                          </div>
                          <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, 1fr)',
                            gap: '6px',
                          }}>
                            {emojis.map((emoji) => (
                              <Button
                                key={emoji}
                                type={selectedEmoji === emoji ? 'primary' : 'default'}
                                onClick={() => handleEmojiSelect(emoji)}
                                style={{
                                  fontSize: '22px',
                                  height: '42px',
                                  width: '100%',
                                  padding: 0,
                                  background: selectedEmoji === emoji ? '#FF69B4' : '#FFFFFF',
                                  borderColor: selectedEmoji === emoji ? '#FF1493' : '#FFB6C1',
                                  borderWidth: '2px',
                                  animation: selectedEmoji === emoji ? 'emojiGlow 1.5s infinite' : 'none',
                                  transform: 'translateZ(0)',
                                }}
                              >
                                {emoji}
                              </Button>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                    {selectedEmoji && (
                      <div style={{
                        marginTop: '6px',
                        textAlign: 'center',
                        color: '#8629A4',
                        fontSize: '12px',
                        fontWeight: '500',
                      }}>
                        Selected: <span style={{ fontSize: '18px' }}>{selectedEmoji}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '12px',
                }}>
                  <Button
                    type="default"
                    icon={<HeartOutlined />}
                    onClick={() => navigate('/womens-message-wall')}
                    style={{
                      height: '44px',
                      background: '#FFFFFF',
                      borderColor: '#FF69B4',
                      color: '#FF1493',
                      fontWeight: '600',
                      fontSize: '15px',
                      borderWidth: '2px',
                    }}
                  >
                    View Posts
                  </Button>
                  <Button
                    type="primary"
                    icon={<SendOutlined />}
                    onClick={handleSubmitMessage}
                    disabled={!message.trim() || message.trim().length < 10}
                    style={{
                      height: '44px',
                      background: 'linear-gradient(135deg, #FF1493 0%, #FF69B4 100%)',
                      borderColor: '#FF1493',
                      fontWeight: '600',
                      fontSize: '15px',
                    }}
                  >
                    Send Message
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    <Header 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontFamily: 'inherit',
        alignItems: 'center',
        background: 'linear-gradient(90deg, #8629A4 0%, #E69CFF 100%)',
        padding: screens.xs ? '0 16px' : '0 24px',
        height: '50px',  
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
      }}
    >
      {/* Logo & Title Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img src={logo} alt="Aptean Logo" style={{ height: '60px', objectFit: 'cover', cursor: 'pointer' }} onClick={() => handleLogoClick()} />
      </div>

      {/* Notification, Help, Profile & Sign Out Section */}
      <Space size={screens.xs ? 16 : 24} style={{ marginRight: '16px' }}>
        {/* <Tooltip
          title="Women Day Special"
          overlayInnerStyle={{
            backgroundColor: '#8629A4',
            color: '#FFFFFF',
            fontSize: '12px',
            borderRadius: '4px',
          }}
          overlayStyle={{
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Button
            type="primary"
            size="small"
            icon={<HeartOutlined />}
            onClick={handleWomenDaySpecial}
            style={{
              background: 'linear-gradient(135deg, #FF1493 0%, #FF69B4 50%, #FFB6C1 100%)',
              borderColor: '#FF1493',
              color: '#FFFFFF',
              borderRadius: '20px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              animation: 'pulse-glow 2s ease-in-out infinite',
              transition: 'all 0.3s ease',
              height: '28px',
              padding: '0 12px',
            }}
          >
            Women Day Special
          </Button>
        </Tooltip> */}
        <CountryFlagDropdown />
        <PendingReviewsBadge />
        <Tooltip
          title="Help"
          overlayInnerStyle={{
            backgroundColor: '#8629A4', // Custom background color
            color: '#FFFFFF', // Custom text color
            fontSize: '12px', // Custom font size
            borderRadius: '4px', // Rounded corners
          }}
          overlayStyle={{
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Custom shadow
          }}
        >
            <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  background: 'rgba(0, 0, 0, 0.25)',
                  cursor: 'pointer',
                  marginRight: '8px',
                }}
                onClick={handlehelp}>
              <QuestionCircleOutlined style={{ width: '20px', height: '20px', color: '#FFFFFF',paddingLeft:'3px',fontWeight:'800' }} />
            </div>
        </Tooltip>
        <NotificationIcon />
        <Tooltip
        title="Sign Out"
        overlayInnerStyle={{
          backgroundColor: '#8629A4', // Custom background color
          color: '#FFFFFF', // Custom text color
          fontSize: '12px', // Custom font size
          borderRadius: '4px', // Rounded corners
        }}
        overlayStyle={{
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Custom shadow
        }}
      >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: 'rgba(0, 0, 0, 0.25)',
              cursor: 'pointer',
            }}
            onClick={handleSignOut} // Add click functionality for logout
          >
            <LogoutOutlined style={{ width: '20px', height: '20px', color: '#FFFFFF',paddingLeft:'3px',fontWeight:'800' }} />
          </div>
        </Tooltip>
      </Space>
    </Header>
    </>
  );
};

export default AppHeaderHomePageTemplate;
